export { default as DashboardMapModalDataText } from './DashboardMapModalDataText';

export type {
  DashboardMapModalDataTextComponent,
  DashboardMapModalDataTextProps,
} from './DashboardMapModalDataText.type';
